import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import DashBoard from '../../components/Dashboard';
import PropertyForm from '../../components/Property/PropertyForm';
import { getList } from '../../redux/modules/user/action';
import { addNewProperty, getTimeline } from '../../redux/modules/property/action';

class AddProperty extends React.Component {
  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(getList());
  }

  addProperty = (formData) => {
    const { dispatch } = this.props;
    dispatch(addNewProperty(formData));
    dispatch(reset('addProperty'));
  }

  getTimelineIds = (event) => {
    const { dispatch } = this.props;
    dispatch(getTimeline(event.target.value));
  }

  render() {
    const { handleSubmit, userList, message, timelineDetails } = this.props;
    return (
      <DashBoard>
        <PropertyForm
          handleSubmit={handleSubmit}
          addProperty={this.addProperty}
          userList={userList}
          message={message}
          formName='Add'
          timelineDetails={timelineDetails}
          getTimelineIds={this.getTimelineIds}
        />
      </DashBoard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userList: state.user.list,
    message: state.property.message,
    timelineDetails: state.property.timelineDetails
  }
}

export default connect(mapStateToProps)(reduxForm({
  form: "addProperty",
  enableReinitialize: true
})(AddProperty));